import { useContext, useEffect, useState } from 'react';
import { SelectedStylepackContext } from './stylepack-context';
import Container from '@ui/container/container';
import Text from '@ui/text/text/text';
import Button from '@ui/buttons/button/button';
import { stylePackBannerImages } from './stylepack-resources';
// TODO pull in when can pull from greenroom's api
// import LoadStylepackThemes from '@/connection/greenroom/load-stylepack-themes';
import Icon from '@ui/icons/icon';
import { ICONS } from '@ui/icons/types';
import classNames from 'classnames';
import styles from './stylepacks.module.css';
import { Link } from 'react-router-dom';
import { stylepackContentTypeMap, type ContentTemplate, VideoType } from '@/types/stylepacks.types';
import OptionalComponent from '@ui/optional-component/optional-component';

// greenroom images need this replacement to work
// https://greenroom-static-assets.greenroom-dev.brandlive.cloud/title_templates/stock_images/ (default image filename)

export default function StylepackHeader() {
  const stylepack = useContext(SelectedStylepackContext).stylepack;
  const [availableTypes, setAvailableTypes] = useState<VideoType[]>(Object.values(VideoType));

  // TODO pull in colors from theme when greenroom api endpoint exists
  // useEffect(() => {
  //   if (stylepack) {
  //     LoadStylepackThemes({ channel: 0, stylepack: 'all' }).then(console.log).catch(console.error);
  //   }
  // }, [stylepack]);

  useEffect(() => {
    if (stylepack?.videos) {
      const availableTypes = stylepack.videos
        .map((video: ContentTemplate) => (video.contentType ? stylepackContentTypeMap[video.contentType] : undefined))
        .filter((type) => !!type);

      setAvailableTypes([VideoType.all, ...Array.from(new Set(availableTypes))]);
    } else {
      setAvailableTypes(Object.values(VideoType));
    }
  }, [stylepack?.videos]);

  return (
    <Container
      backgroundImage={stylePackBannerImages[stylepack.stylePack]}
      width="100%"
      className={classNames('flex flex-column', styles.header, styles[stylepack.name.split(' ').join('')])}
      padding="32px 40px"
      borderRadius="12px"
      gap="16px"
      hoverBackground="transparent"
      transitionDuration="0ms"
    >
      <Container className="flex ai-center jc-space-between" hoverBackground="transparent">
        <Text tag="h2" className="H2">
          {stylepack.name}
        </Text>
        <Link to="./browse" relative="path">
          <Button designSize="large" design="LocalBttnLiquidGlass" className="flex gap-8 ai-center">
            <Icon name={ICONS.REDO_ALT} size={12} />
            <Text className="L1">Switch Stylepack</Text>
          </Button>
        </Link>
      </Container>
      <Container height="4px">{/*Theme colors cannot be loaded due to greenroom api bug - TODO*/}</Container>
      <Container className="flex gap-8">
        <OptionalComponent display={availableTypes.includes(VideoType.countowns)}>
          <Container
            background="var(--global-opacity-black-15)"
            className="flex radius-16 ai-center jc-center"
            padding="4px 12px"
          >
            <Icon name={ICONS.COUNTDOWNS} size={16} />
            <Text className="S2 margin-l-8">Countdowns</Text>
          </Container>
        </OptionalComponent>
        <OptionalComponent display={availableTypes.includes(VideoType.bookends)}>
          <Container
            background="var(--global-opacity-black-15)"
            className="flex radius-16 ai-center jc-center"
            padding="4px 12px"
          >
            <Icon name={ICONS.BOOKENDS} size={16} />
            <Text className="S2 margin-l-8">Bookends</Text>
          </Container>
        </OptionalComponent>
        <OptionalComponent display={availableTypes.includes(VideoType.walkups)}>
          <Container
            background="var(--global-opacity-black-15)"
            className="flex radius-16 ai-center jc-center"
            padding="4px 12px"
          >
            <Icon name={ICONS.WALKUPS} size={16} />
            <Text className="S2 margin-l-8">Walkups</Text>
          </Container>
        </OptionalComponent>
        <OptionalComponent display={availableTypes.includes(VideoType.lowers)}>
          <Container
            background="var(--global-opacity-black-15)"
            className="flex radius-16 ai-center jc-center"
            padding="4px 12px"
          >
            <Icon name={ICONS.LOWERS} size={16} />
            <Text className="S2 margin-l-8">Lowers</Text>
          </Container>
        </OptionalComponent>
        <OptionalComponent display={availableTypes.includes(VideoType.segments)}>
          <Container
            background="var(--global-opacity-black-15)"
            className="flex radius-16 ai-center jc-center"
            padding="4px 12px"
          >
            <Icon name={ICONS.SEGMENTS} size={16} />
            <Text className="S2 margin-l-8">Segments</Text>
          </Container>
        </OptionalComponent>
      </Container>
    </Container>
  );
}
